import { Component, ViewChild } from '@angular/core';
import { ItemShareStockService } from 'src/app/features/stock-summary/services/item-share-stock.service';
import { DataAction } from 'src/app/base/enum/data-action.enum';
import { DialogReturnData } from 'src/app/base/models/dialog-return-data.model';
import { TableColumn } from 'src/app/base/models/table-column.model';
import { TabMenu } from 'primeng/tabmenu';
import { SimpleSearchComponent } from 'src/app/base/components/abstract/simple/simple-search.component';
import { MenuItem } from 'primeng/api';
import { DetailData, ItemShareStock, OrgSummaryData, SummaryData } from 'src/app/features/stock-summary/models/item-share-stock.model';
import { MenuItemId } from 'src/app/base/enum/menu-item-id.enum';
import { Validators } from '@angular/forms';
import { Subject, takeUntil, switchMap, filter as rxFilter, lastValueFrom } from 'rxjs';
import { Option } from 'src/app/base/models/option.model';
import { CommonService } from 'src/app/features/stock-summary/services/common.service';
import { StockSummaryService } from 'src/app/features/stock-summary/services/stock-summary.service';
import { ItemShareLockInquiryCondition } from '../../models/stock-summary-master.model';

@Component({
  selector: 'app-item-share-stock',
  templateUrl: './item-share-stock.component.html',
  styleUrls: ['./item-share-stock.component.scss'],
})
export class ItemShareStockComponent extends SimpleSearchComponent {
  constructor(private itemShareStockService: ItemShareStockService,
    private stockSummaryService: StockSummaryService,
  private commonService: CommonService
  ) {
    super();
  }
  override componentClassName: string = 'ItemShareStockComponent';

  override rowDataKeyName: string = 'uuid';

  override rowDataDeleteHintFieldName: string = 'uuid';

  override hasTableFilter: boolean = true;

  queryId: string = '';
  item?: string = '';
  lockQty?: string = '0';
  reservationQty?: number = 0;
  shareQty?: number = 0;
  queryFailure: boolean = true;

  ouSuggestions: Option[] = [];
  itemSuggestions: Option[] = [];

  detail?: ItemShareStock['detail'] = {};
  summary?: ItemShareStock['summary'] = {};
  orgSummary?: ItemShareStock['orgSummary'] = {};

  override detailDatas: DetailData[] = [];
  // item lock share inquiry 保存原始資料
  private originalDetails: DetailData[] = [];
  private originalSummary: SummaryData[] = [];
  private originalOrgSummary: OrgSummaryData[] = [];

  showShareQty: boolean = false; // 是否顯示總計列

  previousActiveTabId: string = this.parseToId('detail'); // 儲存上次選擇的頁籤 ID
  private readonly ouSubject$ = new Subject<string | undefined>();
  private readonly itemSubject$ = new Subject<string | undefined>();

  // 取得 Table 分頁頁籤物件，後面用來抓頁籤資訊用的
  @ViewChild('detailTabMenuComponent')
  override detailTabMenuComponent!: TabMenu;

  override initFormGroup(): void {
    console.log('dialog data:', this.dynamicDialogConfig?.data);
    this.formGroup = this.formBuilder.nonNullable.group({
      uuid: this.dynamicDialogConfig.data.uuid ?? '',
      ouId: ['', Validators.required],
      itemNumber: ['', Validators.required],
    });
  }
  
  override initTableColumns(): void {
    // 先定義頁籤
    this.detailTabs = [
      {
        id: this.parseToId('detail'),
        label: this.translateService.instant('label.detail'),
        automationId: 'label.detail',
      },
      {
        id: this.parseToId('summary'),
        label: this.translateService.instant('label.summary'),
        automationId: 'label.summary',
      },
      {
        id: this.parseToId('org-summary'),
        label: this.translateService.instant('label.org-summary'),
        automationId: 'label.org-summary',
      },
    ];
    this.detailTabMenuComponent.activeItem = this.detailTabs[1];
    this.previousActiveTabId = this.parseToId('summary');
    this.selectedColumns = this.detailTabColumns[this.parseToId('summary')];
    
    // 設定頁籤 detail 內的欄位
    this.detailTabColumns[this.parseToId('detail')] = [
      {
        header: 'field.seq',
        field: 'seq',
        sortable: true,
      },
      {
        header: 'field.ou',
        field: 'orgId',
        sortable: true,
        filter: { type: 'text', matchMode: 'contains' },
      },
      {
        header: 'field.org',
        field: 'org',
        sortable: true,
        filter: { type: 'text', matchMode: 'contains' },
      },
      {
        header: 'field.inv-org',
        field: 'invOrg',
        sortable: true,
        filter: { type: 'text', matchMode: 'contains' },
      },
      {
        header: 'field.type',
        field: 'type',
        sortable: true,
        filter: { type: 'text', matchMode: 'contains' },
      },
      {
        header: 'field.ord-no',
        field: 'ordNo',
        sortable: true,
        filter: { type: 'text', matchMode: 'contains' },
      },
      {
        header: 'field.order-org',
        field: 'orderOrg',
        sortable: true,
        filter: { type: 'text', matchMode: 'contains' },
      },
      {
        header: 'field.shipping-status',
        field: 'shippingStatus',
        sortable: true,
        filter: { type: 'text', matchMode: 'contains' },
      },
      {
        header: 'field.order-qty',
        field: 'orderQty',
        sortable: true,
        numberField: true,
        filter: { type: 'text', matchMode: 'contains' },
      },
      {
        header: 'field.reservation-qty',
        field: 'reservationQty',
        sortable: true,
        numberField: true,
        filter: { type: 'text', matchMode: 'contains' },
      },
      {
        header: 'field.cust-number',
        field: 'custNumber',
        sortable: true,
        filter: { type: 'text', matchMode: 'contains' },
      },
      {
        header: 'field.cust-name',
        field: 'customerName',
        sortable: true,
        filter: { type: 'text', matchMode: 'contains' },
      },
      {
        header: 'field.sales',
        field: 'sales',
        sortable: true,
        filter: { type: 'text', matchMode: 'contains' },
      },
      {
        header: 'field.dept-name',
        field: 'deptName',
        sortable: true,
        filter: { type: 'text', matchMode: 'contains' },
      },
      {
        header: 'field.source-name',
        field: 'sourceName',
        sortable: true,
        filter: { type: 'text', matchMode: 'contains' },
      },
      {
        header: 'field.lot-no',
        field: 'lotNo',
        sortable: true,
        filter: { type: 'text', matchMode: 'contains' },
      },
      {
        header: 'field.sub-org',
        field: 'subOrg',
        sortable: true,
        filter: { type: 'text', matchMode: 'contains' },
      },
      {
        header: 'field.locator',
        field: 'locator',
        sortable: true,
        filter: { type: 'text', matchMode: 'contains' },
      },
      {
        header: 'field.need-by-date',
        dateField: true,
        dateFormat: 'yyyy/MM/dd',
        field: 'needByDate',
        sortable: true,
        filter: { type: 'text', matchMode: 'contains' },
      },
      {
        header: 'field.crd',
        dateField: true,
        dateFormat: 'yyyy/MM/dd',
        field: 'crd',
        sortable: true,
        filter: { type: 'text', matchMode: 'contains' },
      },
      {
        header: 'field.esd',
        dateField: true,
        dateFormat: 'yyyy/MM/dd',
        field: 'esd',
        sortable: true,
        filter: { type: 'text', matchMode: 'contains' },
      },
      {
        header: 'field.expire-date',
        field: 'expireDate',
        dateField: true,
        sortable: true,
        filter: { type: 'text', matchMode: 'contains' },
      },
      {
        header: 'field.cust-project',
        field: 'customerProject',
        sortable: true,
        filter: { type: 'text', matchMode: 'contains' },
      },
    ];

    this.detailTabColumns[this.parseToId('summary')] = [
      {
        header: 'field.seq',
        field: 'seq',
        sortable: true,
      },
      {
        header: 'field.cust-number',
        field: 'custNumber',
        sortable: true,
        filter: { type: 'text', matchMode: 'contains' },
      },
      {
        header: 'field.cust-name',
        field: 'customerName',
        sortable: true,
        filter: { type: 'text', matchMode: 'contains' },
      },
      {
        header: 'field.sales',
        field: 'sales',
        sortable: true,
        filter: { type: 'text', matchMode: 'contains' },
      },
      {
        header: 'field.dept-name',
        field: 'deptName',
        sortable: true,
        filter: { type: 'text', matchMode: 'contains' },
      },
      {
        header: 'field.reservation-qty',
        field: 'reservationQty',
        sortable: true,
        numberField: true,
        filter: { type: 'text', matchMode: 'contains' },
      },
      {
        header: 'field.share-qty',
        field: 'shareQty',
        sortable: true,
        numberField: true,
        filter: { type: 'text', matchMode: 'contains' },
      },
    ];

    this.detailTabColumns[this.parseToId('org-summary')] = [
      {
        header: 'field.seq',
        field: 'seq',
        sortable: true,
      },
      {
        header: 'field.ou',
        field: 'orgId',
        sortable: true,
        filter: { type: 'text', matchMode: 'contains' },
      },
      {
        header: 'field.org',
        field: 'org',
        sortable: true,
        filter: { type: 'text', matchMode: 'contains' },
      },
      {
        header: 'field.inv-org',
        field: 'invOrg',
        sortable: true,
        filter: { type: 'text', matchMode: 'contains' },
      },
      {
        header: 'field.cust-number',
        field: 'custNumber',
        sortable: true,
        filter: { type: 'text', matchMode: 'contains' },
      },
      {
        header: 'field.cust-name',
        field: 'customerName',
        sortable: true,
        filter: { type: 'text', matchMode: 'contains' },
      },
      {
        header: 'field.sales',
        field: 'sales',
        sortable: true,
        filter: { type: 'text', matchMode: 'contains' },
      },
      {
        header: 'field.dept-name',
        field: 'deptName',
        sortable: true,
        filter: { type: 'text', matchMode: 'contains' },
      },
      {
        header: 'field.reservation-qty',
        field: 'reservationQty',
        sortable: true,
        numberField: true,
        filter: { type: 'text', matchMode: 'contains' },
      },
      {
        header: 'field.share-qty',
        field: 'shareQty',
        sortable: true,
        numberField: true,
        filter: { type: 'text', matchMode: 'contains' },
      },
    ];

    // 把所有頁籤的欄位都設定到 Table Column 內
    this.tableColumns = [
      ...this.detailTabColumns[this.parseToId('detail')],
      ...this.detailTabColumns[this.parseToId('summary')],
      ...this.detailTabColumns[this.parseToId('org-summary')],
    ];

    // 設定目前顯示第一個頁籤的欄位
    this.selectedColumns = this.detailTabColumns[this.parseToId('summary')];
  }

  override async initFormData(): Promise<any> {
    this.loadingMaskService.show();
    // 如果沒有傳入查詢條件，代表從側邊選單點擊，無須執行查詢
    if (this.dynamicDialogConfig?.data.uuid) {
      await this.doQuery(this.dynamicDialogConfig?.data);
    }
    return true;
  }

  override initExtraDetailMenu(): void {
    //將Table上新增按鈕filter掉
    this.detailMenu = [];

    this.detailMenu.push({
      id: this.parseToId(MenuItemId.DETAIL_MENU_FILTER),
      label: this.translateService.instant(MenuItemId.I18N_FILTER),
      automationId: MenuItemId.I18N_FILTER,
      icon: 'pi pi-fw pi-filter',
      command: () => {
        this.detailMenuFilterCommand();
      },
    });
  }

  override afterDetailTabActiveItemChange(): void {
    // 目前點擊的頁籤 ID
    const activeTabId = this.detailTabMenuComponent.activeItem?.id;
    // 用於顯示 summary / org-summary 時的總計（目前未實際計算）
    let currentTotal: any = null;
    /**
     * 共用工具：
     * 1. 重新產生 seq（每個分頁都重新從 1 開始）
     * 2. 補上 rowIndex（給 UI 或其他邏輯使用）
     */
    const applyIndexes = (rows: any[]) =>
      (this.reSeq(rows) as any[]).map((r, i) => ({ ...r, rowIndex: i + 1 })) as any;
    
    /**
     * 如果目前「篩選功能開啟中」
     * 不允許切換頁籤（避免資料錯亂）
     */
    if (this.tableFilterShow) {
      this.systemMessageService.warn('message.filter.close-filter-before-switch');

      // 將頁籤切回原本的頁籤
      this.detailTabMenuComponent.activeItem = this.detailTabs.find(
        (tab) => tab.id === this.previousActiveTabId
      );
      // 依照原本頁籤重新設定資料與欄位
      if (this.previousActiveTabId === this.parseToId('detail')) {
        this.selectedColumns = this.detailTabColumns[this.parseToId('detail')];
        this.detailDatas = applyIndexes(this.detail?.data || []);
        this.showShareQty = false;
      } else if (this.previousActiveTabId === this.parseToId('summary')) {
        this.selectedColumns = this.detailTabColumns[this.parseToId('summary')];
        this.detailDatas = applyIndexes(this.summary?.data || []);
        this.showShareQty = true;
      } else if (this.previousActiveTabId === this.parseToId('org-summary')) {
        this.selectedColumns = this.detailTabColumns[this.parseToId('org-summary')];
        this.detailDatas = applyIndexes(this.orgSummary?.data || []);
        this.showShareQty = true;
      }
      // 恢復 table state（避免 stateStorage 混亂）
      this.tableStateStorageName = `${this.tableStateStorageName}-${this.previousActiveTabId}`;
      // 同步底層 activeItem 狀態
      this.detailTabPreviousActiveItem = this.detailTabs.find(
        (tab) => tab.id === this.previousActiveTabId
      )!;
    } else {
      /**
       * 正常切換頁籤流程
       */
      // 根據目前頁籤決定顯示哪份資料
      if (activeTabId === this.parseToId('detail')) {
        this.selectedColumns = this.detailTabColumns[this.parseToId('detail')];
        this.detailDatas = applyIndexes(this.detail?.data || []);
        this.showShareQty = false;
      } else if (activeTabId === this.parseToId('summary')) {
        this.selectedColumns = this.detailTabColumns[this.parseToId('summary')];
        this.detailDatas = applyIndexes(this.summary?.data || []);
        this.showShareQty = true;
      } else if (activeTabId === this.parseToId('org-summary')) {
        this.selectedColumns = this.detailTabColumns[this.parseToId('org-summary')];
        this.detailDatas = applyIndexes(this.orgSummary?.data || []);
        this.showShareQty = true;
      }
      // 記錄本次頁籤（下次可回復）
      this.previousActiveTabId = activeTabId!;
      // 切換頁籤時重置分頁到第一頁
      this.tableComponent.first = 0;
      // 清除已選取資料（避免跨頁籤殘留選取）
      setTimeout(() => {
        this.rowSelectedDatas = null;
      }, 0);
      /**
       * 若為 summary / org-summary 頁籤
       * 顯示 reservation / share 總計
       */
      if (this.showShareQty) {
        this.reservationQty = currentTotal?.reservationQty;
        this.shareQty = currentTotal?.shareQty;
      }
      // 重新計算目前顯示資料的總計
      this.recalcTotals();
    }
  }

  searchOuSuggestions(event: { query: any }): void {
    if (!this.ouSubject$.observed) {
      this.ouSubject$
        .pipe(
          switchMap((keyword) => this.stockSummaryService.getOrgs(keyword)),
          takeUntil(this._destroying$)
        )
        .subscribe((data) => (this.ouSuggestions = data));
    }
    this.ouSubject$.next(event.query);
  }

  searchItemSuggestions(event: { query: any }): void {
    if (!this.itemSubject$.observed) {
      this.itemSubject$
        .pipe(
          rxFilter(Boolean),
          switchMap((keyword: string) => this.commonService.getItems(keyword)),
          takeUntil(this._destroying$)
        )
        .subscribe({
          next: (data) => (this.itemSuggestions = data),
          error: () => (this.itemSuggestions = []),
        });
    }
    this.itemSubject$.next(event.query);
  }

  override searchReset(): void {
    this.formGroup.reset();
    this.resetItemInfo();
  }

  resetItemInfo(): void {
    this.queryId = '';
    this.item = '';
    this.lockQty = '0';
    this.reservationQty = 0;
    this.shareQty = 0;
    this.showShareQty = false;

    this.detailDatas = [];
    this.detail = {};
    this.summary = {};
    this.orgSummary = {};
  }

  override async doQuery(requeryCondition?: any): Promise<boolean> {
    // 1) 組 request condition
    requeryCondition ??= new ItemShareLockInquiryCondition(
      this.formControl('ouId').getRawValue()?.value,
      this.formControl('itemNumber').getRawValue()?.value,
      ''
    );

    requeryCondition.uuid ??= this.formControl('uuid')?.getRawValue();

    let response: any;
    try {
      response = await lastValueFrom(
        this.itemShareStockService.getItemShareStock(
          requeryCondition as ItemShareLockInquiryCondition
        )
      );
    } catch (e: any) {
      this.systemMessageService.error(e?.message ?? 'Query failed');
      this.queryFailure = true;
      this.resetItemInfo();
      return false;
    }

    // 2) 基本欄位
    this.queryId = response?.queryId ?? '';
    this.queryFailure = !!response?.failure;

    // 3) failure 處理
    if (response?.failure) {
      this.systemMessageService.error(response?.exceptionMsg ?? 'Query failure');
      this.resetItemInfo();
      this.queryId = response?.queryId ?? '';
      this.queryFailure = true;
      return false;
    }

    const data = response?.responseData ?? {};
    this.item = data?.itemNumber ?? '';
    this.lockQty = data?.lockQty ?? 0;

    // 4) 把 array 轉成你原本 tab 要的 { data: [] }
    const detailsArr = (data?.detail ?? []) as DetailData[];
    const summaryArr = (data?.summary ?? []) as SummaryData[];
    const orgSummaryArr = (data?.orgSummary ?? []) as OrgSummaryData[];
    // shipping status 轉換語系
    const detailsWithShippingStatus = detailsArr.map(d => ({
      ...d,
      shippingStatus: this.pickShippingStatus(d),
    }));


    // 保存原始資料
    this.originalDetails = detailsWithShippingStatus;
    this.originalSummary = summaryArr;
    this.originalOrgSummary = orgSummaryArr;

    // 讓 tab 切換時可以用 this.details?.data 取到資料
    this.detail = { data: this.reSeq(detailsWithShippingStatus) } as any;
    this.summary = { data: this.reSeq(summaryArr) } as any;
    this.orgSummary = { data: this.reSeq(orgSummaryArr) } as any;

    // 5) 依「目前 tab」決定畫面顯示哪份資料
    const activeTabId = this.detailTabMenuComponent?.activeItem?.id ?? this.parseToId('summary');

    if (activeTabId === this.parseToId('detail')) {
      this.selectedColumns = this.detailTabColumns[this.parseToId('detail')];
      this.detailDatas = (this.detail?.data || []) as any;
      this.showShareQty = false;
    } else if (activeTabId === this.parseToId('summary')) {
      this.selectedColumns = this.detailTabColumns[this.parseToId('summary')];
      this.detailDatas = (this.summary?.data || []) as any;
      this.showShareQty = true;
    } else {
      this.selectedColumns = this.detailTabColumns[this.parseToId('org-summary')];
      this.detailDatas = (this.orgSummary?.data || []) as any;
      this.showShareQty = true;
    }
    this.previousActiveTabId = activeTabId;

    // 6) rowIndex & totals
    this.detailDatas = (this.detailDatas as any[]).map((r, i) => ({...r,
      rowIndex: i + 1,
    })) as any;
    this.recalcTotals();

    return true;
  }
  
  private toNumber(val: any): number {
    const n = Number(val);
    return Number.isFinite(n) ? n : 0;
  }

  private sumField(rows: any[] | null | undefined, field: string): number {
    if (!rows?.length) return 0;
    return rows.reduce((acc, r) => acc + this.toNumber(r?.[field]), 0);
  }

  /** 用「目前顯示的資料」重算 total */
  private recalcTotals(rows?: any[] | null): void {
    const source = rows ?? (this.detailDatas as any[]) ?? [];

    this.reservationQty = this.sumField(source, 'reservationQty');

    if (this.showShareQty) {
      this.shareQty = this.sumField(source, 'shareQty');
    } else {
      this.shareQty = 0;
    }
  }

  private reSeq<T extends object>(rows: T[] | null | undefined): (T & { seq: number })[] {
    return (rows ?? []).map((r, i) => ({
      ...r,
      seq: i + 1,
    }));
  }

  override onDetailTableFilter(event: any): void {
    // PrimeNG 會把篩選後的資料放在 filteredValue
    const filteredRows = (event?.filteredValue ?? this.detailDatas) as any[];
    this.recalcTotals(filteredRows);
  }

  private pickShippingStatus(d: DetailData): string {
    const lang = this.translateService.currentLang;
    console.log('lang=',lang);
    if (lang === 'en-us') return d.shippingStatusUs ?? '';
    if (lang === 'zh-tw') return d.shippingStatusTw ?? '';
    if (lang === 'zh-cn') return d.shippingStatusCn ?? '';

    return d.shippingStatusTw ?? d.shippingStatusCn ?? d.shippingStatusUs ?? '';
  }

  get displayLockQty(): string {
    if (this.lockQty === null || this.lockQty === undefined) {
      return '';
    }

    // 移除千分位逗號再判斷
    const raw = String(this.lockQty).replace(/,/g, '');
    const num = Number(raw);

    // 是數字補上千分位
    if (!isNaN(num)) {
      return num.toLocaleString('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
    }

    // 是文字原樣顯示
    return String(this.lockQty);
  }

  //以下未實作
  override async beforeQuery(): Promise<boolean> {
    return true;
  }
  override afterSelectedRowDataCountChange(selectedDataCount: number): void {
    return;
  }

  override afterRowDataCountChange(rowDataCount: number): void {
    return;
  }

  override async doDetailMenuBatchDelete(): Promise<boolean> {
    return true;
  }

  override afterDetailMenuStatusChange(): void {
    return;
  }

  override setExtraDetailMenuStatus(): void {
    return;
  }

  override initDialogConfig(dataAction: DataAction): void {
    return;
  }

  override initExtraRowActionMenu(): void {
    return;
  }

  override setExtraRowActionMenuStatus(): void {
    return;
  }

  override doExtraDetailDialogClose(returnData: DialogReturnData): void {
    return;
  }

  override async doRowActionDelete(): Promise<boolean> {
    return true;
  }

  override initStaticOptions(): void {
    return;
  }

  override afterLangChange(): void {
    return;
  }

  override afterFormDataLoadSuccess(): void {
    this.loadingMaskService.hide();
  }

  override afterFormDataLoadFail(): void {
    return;
  }

  override initFormControlDisabled(): void {
    return;
  }

  override async beforeMasterMenuDiscard(): Promise<boolean> {
    return true;
  }

  override async beforeMasterMenuSubmit(): Promise<boolean> {
    return true;
  }

  override async doMasterMenuSubmit(): Promise<boolean> {
    return true;
  }

  override async doMasterMenuDelete(): Promise<boolean> {
    return true;
  }

  override initExtraMasterMenu(): void {
    return;
  }

  override setExtraMasterMenuStatus(): void {
    return;
  }
}
